import { render, staticRenderFns } from "./CardEnderecoEntrega.vue?vue&type=template&id=18d1492e"
import script from "./CardEnderecoEntrega.vue?vue&type=script&lang=js"
export * from "./CardEnderecoEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard,VCardActions})
